import { lazy } from 'react';

// Backup Management (Backup Monitoring)
// V3 surface unifies the previously-separate /backups, /backups/jobs,
// /backups/scopes, /backups/restore-tests into one tabbed narrative.
// Provider/Compliance/Reports/Alerts/Wizards stay separate (admin/setup
// flows outside the V3 operator narrative).
export const BackupDashboard = lazy(() => import('@/capabilities/backup-management/pages/Backups'));

export const BackupJobs = lazy(() => import('@/capabilities/backup-management/pages/Backups'));

export const BackupAssetScopes = lazy(() => import('@/capabilities/backup-management/pages/Backups'));

export const RestoreTestHistory = lazy(() => import('@/capabilities/backup-management/pages/Backups'));

export const BackupProviders = lazy(() =>
  import('@/capabilities/backup-management/pages/BackupProviders').then((m) => ({ default: m.BackupProviders }))
);

export const BackupCompliance = lazy(() =>
  import('@/capabilities/backup-management/pages/BackupCompliance').then((m) => ({ default: m.BackupCompliance }))
);

export const BackupReports = lazy(() =>
  import('@/capabilities/backup-management/pages/BackupReports').then((m) => ({ default: m.BackupReports }))
);

export const BackupAlerts = lazy(() => import('@/capabilities/backup-management/pages/Backups'));

export const BackupProviderWizard = lazy(() =>
  import('@/capabilities/backup-management/pages/BackupProviderWizard').then((m) => ({ default: m.BackupProviderWizard }))
);

export const RestoreTestWizard = lazy(() =>
  import('@/capabilities/backup-management/pages/RestoreTestWizard').then((m) => ({ default: m.RestoreTestWizard }))
);
